import React from "react";
import {Select} from "antd";

const WorkingTypeFilter = ({value, onChange}) => {
    const handleWorkingTypeChange = value => {
        onChange(value);
    };

    return (
        <React.Fragment>
            <Select value={value} onChange={handleWorkingTypeChange}>
                <Select.Option value="all">Tümü</Select.Option>
                <Select.Option value="pool">Havuz</Select.Option>
                <Select.Option value="dedicated">Dedike</Select.Option>
            </Select>
        </React.Fragment>
    );
};

export default WorkingTypeFilter;
